"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlTransformComponentFactory = void 0;
/**
 * @public
 */
class GlTransformComponentFactory {
    constructor(userTransformId, binderId, transformCtor) {
        this.userTransformId = userTransformId;
        this.binderId = binderId;
        this.transformCtor = transformCtor;
    }
    createOne(binder) {
        return new this.transformCtor(binder);
    }
    addToChart(transformFactory) {
        transformFactory.addTransform(this);
    }
}
exports.GlTransformComponentFactory = GlTransformComponentFactory;
//# sourceMappingURL=gl-transform-component-factory.js.map